import {
    BaseSearchComponent,
    SearchComponentEnum,
    SearchComponentGroup,
    SearchComponentType
} from "@/utils/search/types/searchComponent";

const SEARCH_COMPONENT_SEPARATOR = "_";

const getComponentGroup: (
    component: SearchComponentEnum
) => SearchComponentGroup | null = (component) => {
    const separatorIndex = component.indexOf(SEARCH_COMPONENT_SEPARATOR);
    return separatorIndex > -1
        ? (component.slice(0, separatorIndex) as SearchComponentGroup)
        : null;
};

const getComponentType: (
    component: SearchComponentEnum
) => SearchComponentType | null = (component) => {
    const separatorIndex = component.indexOf(SEARCH_COMPONENT_SEPARATOR);
    return separatorIndex > -1
        ? (component.slice(separatorIndex + 1) as SearchComponentType)
        : null;
};

const createSearchComponentEnum = (
    group: SearchComponentGroup,
    type: SearchComponentType
) => `${group}${SEARCH_COMPONENT_SEPARATOR}${type}` as SearchComponentEnum;

const createTypeInGroup = (
    component: SearchComponentEnum,
    type: SearchComponentType
) => {
    const group = getComponentGroup(component);
    if (!group) return;

    return createSearchComponentEnum(group, type);
};

const isGroup: (
    component: SearchComponentEnum,
    componentGroup: SearchComponentGroup
) => boolean = (component, componentGroup) =>
    getComponentGroup(component) === componentGroup;

const isAnyGroup: (
    component: SearchComponentEnum,
    componentGroups: Array<SearchComponentGroup>
) => boolean = (component, componentGroups) =>
    componentGroups.some((componentGroup) =>
        isGroup(component, componentGroup)
    );

const isType = <TType extends BaseSearchComponent>(
    component: BaseSearchComponent,
    componentType: SearchComponentType
): component is TType =>
    getComponentType(component.component) === componentType;

export {
    createSearchComponentEnum,
    createTypeInGroup,
    getComponentGroup,
    getComponentType,
    isAnyGroup,
    isGroup,
    isType
};
